import React, { useState, useEffect } from "react";
import "../ftp.css";

const ProductCard = ({ product }) => {
  const [selectedColor, setSelectedColor] = useState(product.colors?.[0] || "");
  const [selectedSize, setSelectedSize] = useState(product.sizes?.[0] || "");

  const images = product.images?.[selectedColor] || [];
  const defaultImage = images[0] || "placeholder.jpg"; // Fallback image

  const handleColorChange = (e) => {
    setSelectedColor(e.target.value);
  };

  const handleSizeChange = (e) => {
    setSelectedSize(e.target.value);
  };

  const priceKey = `${selectedColor}-${selectedSize}`;
  const selectedPrice = product.prices?.[priceKey] || "Price not available";

  return (
    <div className="product-cardftp">
      <div className="product-image-containerftp">
        <img
          src={defaultImage}
          alt={`Product ${product.handle} in ${selectedColor}`}
          className="product-imageftp"
        />
      </div>

      <h3>{product.handle}</h3>

      <label htmlFor="size">Select Size:</label>
      <select id="size" value={selectedSize} onChange={handleSizeChange} className="size-dropdownftp">
        {product.sizes?.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>

      <label htmlFor="color">Select Color:</label>
      <select id="color" value={selectedColor} onChange={handleColorChange} className="color-dropdownftp">
        {product.colors?.map((color) => (
          <option key={color} value={color}>
            {color}
          </option>
        ))}
      </select>

      <p className="product-priceftp">Price: ${selectedPrice}</p>
      <div
                    className="product-det"
                    style={{ fontSize: '10px',   textAlign: 'left', marginLeft:-20}}
                    dangerouslySetInnerHTML={{ __html: product.body }} />
    </div>
  );
};

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 20;

  useEffect(() => {
    fetch("http://localhost:9000/sanmarFtp")
      .then((response) => response.json())
      .then((data) => {
        setProducts(data);
        setFilteredProducts(data); // Ensure all products are initially displayed
      })
      .catch((error) => console.error("Error fetching products:", error));
  }, []);

  // Handle search input change
  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (!query) {
      setFilteredProducts(products); // Show all if search is cleared
    } else {
      setFilteredProducts(products.filter((product) => product.handle.toLowerCase().includes(query)));
    }

    setCurrentPage(1); // Reset to first page when searching
  };

  // Pagination logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <div>
      {/* Search Input */}
      <input
        type="text"
        placeholder="Search by product handle..."
        value={searchQuery}
        onChange={handleSearchChange}
        className="search-inputftp"
      />

      {/* Product Grid */}
      <div className="product-listftp">
        {currentProducts.length > 0 ? (
          currentProducts.map((product) => <ProductCard key={product.handle} product={product} />)
        ) : (
          <p>No products found.</p>
        )}
      </div>

      {/* Pagination Controls */}
      {filteredProducts.length > productsPerPage && (
        <div className="pagination-controlsftp">
          <button onClick={prevPage} disabled={currentPage === 1}>
            Prev
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button onClick={nextPage} disabled={currentPage === totalPages}>
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductList;
